export const ETAPAS_FUNIL = {
  lead: { label: "Lead", color: "#6b7280" },
  contato: { label: "Contato", color: "#3b82f6" },
  visita: { label: "Visita", color: "#0891b2" },
  proposta: { label: "Levantamento de proposta", color: "#7c3aed" },
  analise: { label: "Análise", color: "#ca8a04" },
  contrato: { label: "Contrato", color: "#F97316" },
  efetivado: { label: "Concluído", color: "#16a34a" },
};

export const etapaInfo = (id) => ETAPAS_FUNIL[id] || { label: id || "Sem etapa", color: "#6b7280" };
